import React from "react";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiJava,
} from "react-icons/di";
import { TbBrandNextjs, TbBrandGolang } from "react-icons/tb";
import {
  SiDart,
  SiFlutter,
  SiSpringboot,
  SiExpress,
  SiSequelize,
  SiReact,
  SiFastapi,
  SiDocker,
  SiAmazonaws,
  SiFirebase,
  SiOpenai
} from "react-icons/si";
import { TbVectorTriangle } from "react-icons/tb";

const calculateExperience = (startDate) => {
  const start = new Date(startDate);
  const now = new Date();
  const diffTime = Math.abs(now - start);
  const diffMonths = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30));
  return diffMonths;
};

const TechIcon = ({ icon: Icon, name, category, startDate }) => {
  const experience = calculateExperience(startDate);
  
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={`tooltip-${name}`} className="custom-tooltip">
          <div className="tooltip-content">
            <span className="tooltip-category">{category}</span>
            <strong className="tooltip-title">{name}</strong>
            <span className="experience-text">{experience} months</span>
          </div>
        </Tooltip>
      }
    >
      <Col xs={4} md={2} className="tech-icons">
        <div className="tech-icon-wrapper">
          <Icon className="tech-icon" />
        </div>
      </Col>
    </OverlayTrigger>
  );
};

function Techstack() {
  const techStack = [
    { icon: DiJavascript1, name: "JavaScript", category: "Language", startDate: "2023-08-01" },
    { icon: DiJava, name: "Java", category: "Language", startDate: "2023-08-01" },
    { icon: TbBrandGolang, name: "Go", category: "Language", startDate: "2024-05-01" },
    { icon: DiPython, name: "Python", category: "Language", startDate: "2023-10-01" },
    { icon: SiDart, name: "Dart", category: "Language", startDate: "2024-02-01" },
    { icon: DiNodejs, name: "Node.js", category: "Runtime", startDate: "2023-11-01" },
    { icon: TbBrandNextjs, name: "Next.js", category: "Framework", startDate: "2024-04-01" },
    { icon: DiReact, name: "React", category: "Library", startDate: "2023-11-01" },
    { icon: SiReact, name: "React Native", category: "Framework", startDate: "2024-02-01" },
    { icon: SiFlutter, name: "Flutter", category: "Framework", startDate: "2024-02-01" },
    { icon: SiSpringboot, name: "Spring Boot", category: "Framework", startDate: "2024-01-01" },
    { icon: SiExpress, name: "Express", category: "Framework", startDate: "2023-11-01" },
    { icon: SiFastapi, name: "FastAPI", category: "Framework", startDate: "2024-06-01" },
    { icon: DiMongodb, name: "MongoDB", category: "Database", startDate: "2023-11-01" },
    { icon: SiFirebase, name: "Firebase", category: "Database", startDate: "2024-03-01" },
    { icon: SiSequelize, name: "Sequelize", category: "ORM", startDate: "2024-03-01" },
    { icon: SiDocker, name: "Docker", category: "DevOps", startDate: "2024-05-01" },
    { icon: SiAmazonaws, name: "AWS", category: "Cloud", startDate: "2024-06-01" },
    { icon: DiGit, name: "Git", category: "Version Control", startDate: "2023-09-01" },
    { icon: SiOpenai, name: "OpenAI API", category: "AI/ML", startDate: "2024-04-01" },
    { icon: TbVectorTriangle, name: "Pinecone", category: "Vector DB", startDate: "2024-07-01" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {techStack.map((tech, index) => (
        <TechIcon key={index} {...tech} />
      ))}
    </Row>
  );
}

export default Techstack;
